var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.routename, _vm.auth],attrs:{"id":"app-content"}},[_c('header-component'),_vm._v(" "),_c('transition',{attrs:{"name":"routefade","mode":"out-in"},on:{"beforeLeave":_vm.routeupdate,"afterLeave":_vm.routeafterleave}},[_c('router-view',{key:_vm.$route.fullPath})],1),_vm._v(" "),_c('cookies')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }